import { useEffect } from "react";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { Label, InputField, DropdownBox } from "../../../../../../CommonComponents";
import userManageOperations from '../../../../../../../redux/UserManagement/operations'
import { useDispatch, useSelector } from "react-redux";

const AddSecurityRolePopup = ({
  selectedKeys,
  roleError,
  onRoleChange,
  rolesData,
  securityRoleById,
  actionType,
  selectedUserId,
  rolesEditData,
  roleForm,
  onEditRoleChange,
  addUserData
}: any) => {
  const { getUserDetails }: any = useSelector(
    (state: any) => ({
      getUserDetails: state.UserProfile.getUserDetails
    })
  )
  const accountName = getUserDetails?.userName;
  const dispatch = useDispatch();
  const dispatchGetActiveRoles = userManageOperations.dispatchGetActiveRoles(dispatch);
  useEffect(() => {
    dispatchGetActiveRoles(selectedUserId || addUserData)
  }, [])

  return (
    <div className="permissionPopUpClass">
      <div className="pool-grid-block">
        <div>
          <Label required data-attribute="AddSecurityRolePopup_Default_Label">Role Name</Label>
          {(actionType == "edit") ? <DropdownBox
            placeholder="Select options"
            selectedKey={roleForm?.roleIds}
            value={roleForm?.roleIds?.toString()}
            options={rolesEditData}
            onChange={onEditRoleChange}
           data-attribute="AddSecurityRolePopup_Default_Dropdown" /> : <Dropdown
            placeholder="Select options"
            selectedKeys={selectedKeys}
            multiSelect
            options={rolesData}
            onChange={onRoleChange}
           data-attribute="AddSecurityRolePopup_Default_Dropdown_2" />}

          {roleError?.roleNameError ? (
            <span className="asset-validation-msg">
              {roleError?.roleNameError}
            </span>
          ) : null}
        </div>
        <div className="topPadding">
          <Label data-attribute="AddSecurityRolePopup_Default_Label_2">Provided By</Label>
          <InputField
            placeholder="Provided By"
            disabled={true}
            name={"providedBy"}
            value={securityRoleById?.providedBy ? securityRoleById?.providedBy : accountName}
           data-attribute="AddSecurityRolePopup_providedBy_Input" />
        </div>
      </div>
    </div>
  );
};
export default AddSecurityRolePopup;
